// Mirrors $primary in ./color.scss — this is the single source of truth
// for the brand primary color wherever a JS (inline style) value is needed.
export const PRIMARY_COLOR = "#00416CCC";
